import styled from 'styled-components';

export const Layout = styled.div`
  padding: 16px;
  font-size: 30px;

  align-items: center;
  color: #010101;

  input {
    width: 100%;
    box-sizing: border-box;
    margin: 0;
  }

  h1 {
    margin-bottom: 15px;
    font-size: 40px;
  }

  h2 {
    font-size: 35px;
    font-weight: 600;
    margin-bottom: 5px;
  }
`;
